import { Component, inject, signal } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { ActivatedRoute, RouterModule } from '@angular/router';
import { NzButtonModule } from 'ng-zorro-antd/button';
import { NzCardModule } from 'ng-zorro-antd/card';
import { NzCheckboxModule } from 'ng-zorro-antd/checkbox';
import { NzDividerComponent } from 'ng-zorro-antd/divider';
import { NzFormModule } from 'ng-zorro-antd/form';
import { NzIconModule } from 'ng-zorro-antd/icon';
import { NzInputModule } from 'ng-zorro-antd/input';
import { map } from 'rxjs/internal/operators/map';
import { IcdCodeType } from '../../../../core/api/mhsConfigurationApiClient';
import { CodeData } from '../../dto/code-data';
import { CodesService } from '../../services/codes-service';
@Component({
  selector: 'app-icd-code-edit',
  imports: [
    FormsModule,
    NzIconModule,
    NzFormModule,
    NzInputModule,
    NzButtonModule,
    NzCardModule,
    NzDividerComponent,
    RouterModule,
    NzCheckboxModule,
  ],
  templateUrl: './icd-code-edit.html',
  styleUrl: './icd-code-edit.scss',
})
export class IcdCodeEditComponent {
  private readonly route = inject(ActivatedRoute);
  private readonly codesService = inject(CodesService);

  readonly type = this.route.snapshot.data['codeType'] as IcdCodeType;
  readonly title = this.type.replace('Icd', 'ICD-');
  readonly code = this.route.snapshot.paramMap.get('codeId') ?? '';
  readonly isSubmitting = signal(false);

  readonly model = signal<CodeData | null>(null);
  ngOnInit() {
    this.codesService
      .get(this.type, this.code)
      .pipe(
        map(
          (details): CodeData => ({
            code: details.code!,
            name: details.name!,
            isVerified: details.isVerified!,
          }),
        ),
      )
      .subscribe((data) => {
        this.model.set(data);
      });
  }
  submit(): void {
    const value = this.model();
    this.isSubmitting.set(true);
  }
}
